import ConfigService from '../index'
class CheckListDBService extends ConfigService {
    constructor(){
        super('checklistdb/api/v1/')
    }
}
export default CheckListDBService
